import { Box } from '@mui/material';
import React, { useRef, useState } from 'react';
import { Form, Formik } from 'formik';

import { sxConfig } from './joker.style';
import { FormButtonPanelUI } from '../Interface';
import jokerService from '../../service/joker.service';
import { normalizeJokerFields } from '../../utils/jokerHelper';
import Yup from '../../utils/yup';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';
import { JokerForm } from './JokerForm';

export const JokerPage = () => {
  const defValues = { type: null, groupId: null, fields: [] };

  const [initValues, setInitValues] = useState(defValues);
  const [isInitialized, setIsInitialized] = useState(false);

  const valuesToForm = (data, type, groupId) => {
    const mapped = {
      type: type,
      groupId: groupId,
      fields: data.map((item) => ({
        id: item.id,
        name: item.name,
        field: item.field,
        isRow: item.isRow,
        isNew: item?.isNew ?? false,
        jokerValues: item.jokerValues,
        groupped: item?.jokerGroups?.length > 0 ?? false,
        visOrder: item.visOrder,
      })),
    };
    setInitValues(mapped);
    setIsInitialized(true);
  };

  const handleSave = (values) => {
    const body = {
      ...values,
      fields: values.fields
        .filter((row) => row.name.trim())
        .map((row) => ({
          ...row,
          id: row.isNew ? undefined : row.id,
          jokerValues: row.jokerValues.map((val) => ({
            ...val,
            id: val.isNew ? undefined : val.id,
          })),
        })),
    };

    jokerService.upsertEditorField(body).then((data) => {
      addNotification({
        content: `Sikeres mentés!`,
        type: NotificationType.SUCCESS,
      });

      const normalized = normalizeJokerFields(data, values.type, values.groupId === -1 ? true : false);
      valuesToForm(normalized, values.type, values.groupId);
    });
  };

  const validationSchema = Yup.object().shape({
    type: Yup.string().required(),
    groupId: Yup.string().required(),
    fields: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().nullable(),
        visOrder: Yup.number().when('groupped', {
          is: true,
          then: (schema) => schema.required(),
          otherwise: (schema) => schema.nullable(),
        }),
        jokerValues: Yup.array().of(
          Yup.object().shape({
            value: Yup.string().required(),
            label: Yup.string().required(),
          })
        ),
      })
    ),
  });

  return (
    <>
      <Box sx={sxConfig.containerBox}>
        <Box sx={sxConfig.wrapperBox}>
          <Formik
            initialValues={initValues}
            validationSchema={validationSchema}
            validateOnChange={false}
            onSubmit={handleSave}
            enableReinitialize
          >
            {({ dirty, resetForm }) => {
              const safeDirty = isInitialized && dirty;
              return (
                <Form>
                  <JokerForm valuesToForm={valuesToForm} isDirty={safeDirty} setIsInitialized={setIsInitialized} />
                  <FormButtonPanelUI
                    onCancelClick={() => {
                      resetForm();
                    }}
                  />
                </Form>
              );
            }}
          </Formik>
        </Box>
      </Box>
    </>
  );
};
